import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-select-mobile-standard-options',
  templateUrl: './select-mobile-standard-options.component.html',
  styleUrls: ['./select-mobile-standard-options.component.scss'],
})
export class SelectMobileStandardOptionsComponent implements OnInit {
  @Input()title: string = "";
  @Input()optionsList: any[];
  @Input()codedList: boolean = false; //verifica si la lista de opciones es un array simple o un array de objetos con el codigo x opcion

  constructor(
    public modalController: ModalController,
  ) { }

  ngOnInit() {}

  async onSelectedOption(selectedValue: any) {
    await this.modalController.dismiss(selectedValue);
  }

  closeModal() {
		this.modalController.dismiss();
	}

  controlPropagation(e) {
		e.stopPropagation();
	}
}
